// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#stawag-comparison-staging-gjuce ul[data-v-0a7d532f]{list-style:square;padding:0;list-style-position:inside}", ""]);
// Exports
module.exports = exports;
